import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleVisible, handleDangerVisible } from "../../global/Utils";
import {
  addReceiving,
  getNextReceivingNumber,
} from "../../Actions/ReceivingAction";
import { getCompany } from "../../Actions/CompanyAction";
import ReceivingForm, { blankValues } from "./ReceivingForm";

/**
 * Records goods received from a supplier. Saving writes positive RECEIVING rows
 * to the stock ledger, one per line - nothing here touches stock directly.
 */
const AddReceiving = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isAddingReceiving = useSelector(
    (state) => state.ReceivingReducer?.isAddingReceiving,
  );
  const nextReceivingNumber = useSelector(
    (state) => state.ReceivingReducer?.nextReceivingNumber,
  );

  useEffect(() => {
    // The number comes from the server's running sequence rather than being
    // guessed here. It is regenerated on save if the request leaves it blank.
    dispatch(getNextReceivingNumber());
    dispatch(getCompany("", "", ""));
  }, [dispatch]);

  const initial = useMemo(
    () => ({ ...blankValues(), receivingNumber: nextReceivingNumber || "" }),
    [nextReceivingNumber],
  );

  const handleSubmit = (payload) => {
    dispatch(
      addReceiving(payload, handleVisible, handleDangerVisible, () =>
        navigate("/main/view-receiving-list"),
      ),
    );
  };

  return (
    <ReceivingForm
      initial={initial}
      submitLabel="Add Receiving"
      submitting={isAddingReceiving}
      onSubmit={handleSubmit}
    />
  );
};

export default AddReceiving;
